interface AssemblyDateFiltersProps {
  dates: string[]
}

export const AssemblyDateFilters = ({ dates }: AssemblyDateFiltersProps) => {
  if (dates.length === 0) return null

  return (
    <div className="filter-content w-[180px] max-h-[200px] bg-white absolute top-[108px] right-5 z-50 rounded-lg flex flex-col gap-2 py-1 px-2 overflow-y-auto">
      {dates.map((date) => (
        <div
          key={date}
          className="hover:bg-slate-100 rounded-lg py-2 px-2 relative group cursor-pointer"
          id={date}
        >
          {date}
          <span className="hidden group-hover:block absolute top-[13px] left-0 h-[15px] w-[3px] bg-blue-600 rounded-lg" />
        </div>
      ))}
    </div>
  )
}
